import React from "react";
import Icon from "components/AppIcon";

const DataTable = ({
  columns,
  data,
  isLoading,
  error,
  onSort,
  onRetry,
  emptyMessage,
  currentPage,
  itemsPerPage,
  onAction,
}) => {
  const renderHeader = () => (
    <thead className="bg-gray-50 whitespace-nowrap">
      <tr>
        {columns.map((col) => (
          <th
            key={col.key}
            className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${col.sortable ? "cursor-pointer select-none" : ""
              }`}
            onClick={() => col.sortable && onSort(col.key)}
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );

  const renderRows = () => (
    <tbody className="bg-white divide-y divide-gray-200 whitespace-nowrap">
      {data.map((item, index) => (
        <tr key={index} className="hover:bg-gray-50">
          {columns.map((col) => {
            let value;
            if (col.key === "sno") value = index + 1 + (currentPage - 1) * itemsPerPage;
            else if (col.key === "lastSeen") {
              value = new Date(item[col.key]).toLocaleDateString();
            }
            else if (col.key === "jsonString") {
              const fullText = item[col.key];
              value = fullText ? (
                <button
                  type="button"
                  onClick={() => onAction(item, "viewContent")}
                  className="text-left text-primary-600 hover:text-primary-700 focus:outline-none"
                  title={'Error Details'}
                >
                  <span className="block max-w-[260px] truncate">{fullText}</span>
                </button>
              ) : (
                <span className="text-gray-400">-</span>
              );
            } else {
              value = item[col.key] ?? "-";
            }

            return (
              <td
                key={col.key}
                className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap"
              >
                {value}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );

  const renderError = () => (
    <tbody className="whitespace-nowrap">
      <tr>
        <td colSpan={columns.length} className="px-6 py-12 text-center text-sm text-gray-500">
          <div className="flex flex-col items-center">
            <Icon name="AlertCircle" size={32} className="text-error mb-2" />
            <p className="font-medium mb-2">{error}</p>
            <button
              onClick={onRetry}
              className="mt-2 px-3 py-2 bg-primary-600 text-white text-sm rounded-md hover:bg-primary-700"
            >
              Retry
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  );

  const renderEmpty = () => (
    <tbody className="whitespace-nowrap">
      <tr>
        <td colSpan={columns.length} className="px-6 py-12 text-center text-sm text-gray-500">
          <div className="flex flex-col items-center">
            <Icon name="Search" size={32} className="text-gray-400 mb-2" />
            <p className="font-medium mb-2">{emptyMessage}</p>
          </div>
        </td>
      </tr>
    </tbody>
  );

  const renderLoading = () => (
    <tbody className="bg-white divide-y divide-gray-200 whitespace-nowrap">
      {[...Array(3)].map((_, index) => (
        <tr key={index}>
          {columns.map((_, i) => (
            <td key={i} className="px-6 py-4">
              <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  return (
    <div className="!overflow-x-auto">
      <table className="w-full">
        {renderHeader()}
        {isLoading
          ? renderLoading()
          : error
            ? renderError()
            : data.length === 0
              ? renderEmpty()
              : renderRows()}
      </table>
    </div>
  );
};

export default DataTable;